// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"5223":"cc2bd7f2","7523":"e4e72636"}[chunkId] + ".css";
};